import React, { useState, useEffect, useMemo } from "react";
import { Table, Button, Input, Spin, Tag } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { encryptData, decryptData } from "../../decryptHelper";

export default function Resulthistory() {
  const navigate = useNavigate();

  // =========================================================
  // ROUTE PARAMS
  // =========================================================
  const { date, child_mob } = useParams();

  // =========================================================
  // LOCAL STORAGE
  // =========================================================
  const user_id = localStorage.getItem("userid");

  // =========================================================
  // STATES
  // =========================================================
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [apiResponse, setApiResponse] = useState(null);

  // =========================================================
  // FORMAT TABLE VALUE
  // =========================================================
  const formatValue = (value) => {
    if (value === null || value === undefined || value === "") {
      return "-";
    }

    if (typeof value === "object") {
      return (
        <pre
          style={{
            margin: 0,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            fontSize: "12px",
          }}
        >
          {JSON.stringify(value, null, 2)}
        </pre>
      );
    }

    return String(value);
  };

  // =========================================================
  // HELPER: FIND FIELD BY MULTIPLE POSSIBLE NAMES
  // =========================================================
  const findField = (item, possibleNames) => {
    if (!item || typeof item !== "object") return undefined;

    const keys = Object.keys(item);

    for (const name of possibleNames) {
      const exactKey = keys.find(
        (k) => k.toLowerCase() === name.toLowerCase()
      );

      if (
        exactKey &&
        item[exactKey] !== undefined &&
        item[exactKey] !== null &&
        item[exactKey] !== ""
      ) {
        return item[exactKey];
      }
    }

    return undefined;
  };

  // =========================================================
  // BONUS REPORT API
  // =========================================================
  const fetchBonusReport = async () => {
    try {
      setIsLoading(true);

      console.log("======================================");
      console.log("BONUS REPORT SECOND API");
      console.log("======================================");
      console.log("USER ID:", user_id);
      console.log("DATE:", date);
      console.log("CHILD MOBILE:", child_mob);

      if (!user_id) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "User ID not found in localStorage",
        });

        setData([]);
        setFilteredData([]);
        return;
      }

      const requestData = {
        user_id: user_id,
        date: date || "",
        child_mob: child_mob || "",
      };

      console.log("REQUEST DATA:", requestData);

      const encryptedText = encryptData(requestData);
      const datasend = { data: encryptedText };

      console.log("FINAL REQUEST:", datasend);

      const apiUrl = `${process.env.REACT_APP_API_URL_NODE}bonus-report-list-details-second`;
      console.log("API URL:", apiUrl);

      const response1 = await axios.post(apiUrl, datasend, {
        headers: { "Content-Type": "application/json" },
      });

      console.log("======================================");
      console.log("RAW API RESPONSE");
      console.log("======================================");
      console.warn("ramraj gurjar", response1.data);

      if (!response1?.data?.encryptedResponse) {
        console.error("encryptedResponse NOT FOUND");

        setData([]);
        setFilteredData([]);

        Swal.fire({
          icon: "error",
          title: "API Error",
          text: "encryptedResponse not found",
        });

        return;
      }

      const decryptedResponse = decryptData(
        response1.data.encryptedResponse
      );

      console.log("======================================");
      console.log("DECRYPTED RESPONSE");
      console.log("======================================");
      console.log(decryptedResponse);
      console.log("TYPE:", typeof decryptedResponse);

      setApiResponse(decryptedResponse);

      let result = decryptedResponse;
      let apiData = [];

      if (Array.isArray(result?.data?.data)) {
        apiData = result.data.data;
      } else if (Array.isArray(result?.data)) {
        apiData = result.data;
      } else if (Array.isArray(result)) {
        apiData = result;
      } else if (Array.isArray(result?.result?.data)) {
        apiData = result.result.data;
      }

      console.log("======================================");
      console.log("FINAL TABLE DATA");
      console.log("======================================");
      console.log(apiData);
      console.log("TOTAL RECORDS:", apiData.length);

      const success =
        result?.data?.success === "1" ||
        result?.data?.success === 1 ||
        result?.data?.success === true ||
        result?.success === "1" ||
        result?.success === 1 ||
        result?.success === true ||
        result?.data?.status === "1" ||
        result?.data?.status === 1 ||
        result?.data?.status === true ||
        result?.status === "1" ||
        result?.status === 1 ||
        result?.status === true;

      if (success || apiData.length > 0) {
        setData(apiData);
        setFilteredData(apiData);
        console.log("DATA SUCCESSFULLY SET");
      } else {
        setData([]);
        setFilteredData([]);
        console.log("NO DATA FOUND");

        Swal.fire({
          icon: "info",
          title: "No Data",
          text:
            result?.data?.message ||
            result?.message ||
            "No bonus report data found",
        });
      }
    } catch (error) {
      console.error("======================================");
      console.error("BONUS SECOND API ERROR");
      console.error("======================================");
      console.error("ERROR:", error);
      console.error("STATUS:", error?.response?.status);
      console.error("RESPONSE:", error?.response?.data);
      console.error("URL:", error?.config?.url);

      setData([]);
      setFilteredData([]);

      Swal.fire({
        icon: "error",
        title: "API Error",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Something went wrong while fetching data",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // =========================================================
  // API CALL
  // =========================================================
  useEffect(() => {
    fetchBonusReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, child_mob]);

  // =========================================================
  // SEARCH
  // =========================================================
  useEffect(() => {
    if (!searchText.trim()) {
      setFilteredData(data);
      return;
    }

    const search = searchText.toLowerCase().trim();

    const filtered = data.filter((item) => {
      return Object.values(item || {}).some((value) => {
        if (value === null || value === undefined) return false;

        if (typeof value === "object") {
          return JSON.stringify(value).toLowerCase().includes(search);
        }

        return String(value).toLowerCase().includes(search);
      });
    });

    setFilteredData(filtered);
  }, [searchText, data]);

  // =========================================================
  // FIXED TABLE COLUMNS
  // Sirf 3 columns: Win Value, Market, Child Mob
  // =========================================================
  // const tableColumns = useMemo(() => {
  //   return [
    

  //     {
  //       title: "Market",
  //       key: "market",
  //       width: 200,
  //       render: (_, record) => {
  //         const val = findField(record, [
  //           "table_id",
  //           "market",
  //           "market_name",
  //           "tableId",
  //           "game",
  //         ]);
  //         return val !== undefined ? val : "-";
  //       },
  //     },

  //     {
  //       title: "Child Mob",
  //       key: "child_mob",
  //       width: 180,
  //       render: (_, record) => {
  //         const val = findField(record, [
  //           "child_mob",
  //           "childMob",
  //           "child_mobile",
  //           "childMobile",
  //           "child_mob_no",
  //         ]);
  //         return val !== undefined ? val : "-";
  //       },
  //     },
  //       {
  //       title: " Bonus Amount ",
  //       key: "win_value",
  //       width: 150,
  //       render: (_, record) => {
  //         const val = findField(record, [
  //           "win_value",
  //           "winValue",
  //           "winvalue",
  //           "win_amount",
  //           "winAmount",
  //           "winning",
  //           "win",
  //         ]);
  //         return val !== undefined ? val : "-";
  //       },
  //     },
  //        {
  //     title: "Total Played",
  //     dataIndex: "tr_value",
  //     key: "tr_value",
  //   },
  //   ];
  // }, []);
    // =========================================================
  // FIXED TABLE COLUMNS (4 COLUMNS)
  // Market, Child Mob, Bonus Amount, Total Played
  // =========================================================
  const tableColumns = useMemo(() => {
    return [
      {
        title: "Market",
        key: "market",
        align: "left",
        ellipsis: true,
        render: (_, record) => {
          const val = findField(record, [
            "table_id",
            "market",
            "market_name",
            "tableId",
            "game",
          ]);
          return val !== undefined ? val : "-";
        },
      },
      {
        title: "Child Mob",
        key: "child_mob",
        width: 180,
        align: "left",
        ellipsis: true,
        render: (_, record) => {
          const val = findField(record, [
            "child_mob",
            "childMob",
            "child_mobile",
            "childMobile",
            "child_mob_no",
          ]);
          return val !== undefined ? val : "-";
        },
      },
      {
        title: "Bonus Amount",
        key: "bonus_amount",
        width: 150,
        align: "center",
        render: (_, record) => {
          const val = findField(record, [
            "bonus_amount",
            "bonusAmount",
            "bonus",
            "bonus_amt",
            "win_value",
            "winValue",
          ]);
          return val !== undefined ? val : "-";
        },
      },
      {
        title: "Total Played",
        key: "total_played",
        width: 150,
        align: "center",
        render: (_, record) => {
          const val = findField(record, [
            "tr_value",
            "trValue",
            "total_played",
            "totalPlayed",
            "total_played_amount",
          ]);
          return val !== undefined ? val : "-";
        },
      },
    ];
  }, []);
  

  // =========================================================
  // UI
  // =========================================================
  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "16px",
        background: "#f5f6fa",
      }}
    >
      {/* SEARCH */}
      <div
        style={{
          background: "#ffffff",
          padding: "15px",
          borderRadius: "10px",
          marginBottom: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "15px",
          flexWrap: "wrap",
        }}
      >
        {/* <Input
          placeholder="Search..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ maxWidth: 300 }}
          allowClear
        /> */}
      </div>

      {/* TABLE */}
      <div
        style={{
          background: "#ffffff",
          padding: "15px",
          borderRadius: "10px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        }}
      >
        {/* <Table
          columns={tableColumns}
          dataSource={filteredData}
          loading={{
            spinning: isLoading,
            indicator: <Spin size="large" />,
          }}
          rowKey={(record, index) =>
            record?.id || record?._id || record?.child_mob || `${index}`
          }
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} records`,
          }}
          bordered
          locale={{
            emptyText: isLoading ? "Loading..." : "No bonus data found",
          }}
        /> */}
          <Table
            tableLayout="auto"
    columns={tableColumns}
    dataSource={filteredData}
    loading={{
      spinning: isLoading,
      indicator: <Spin size="large" />,
    }}
    rowKey={(record, index) =>
      record?.id || record?._id || record?.child_mob || `${index}`
    }
    pagination={{
      pageSize: 10,
      showSizeChanger: true,
      showTotal: (total, range) =>
        `${range[0]}-${range[1]} of ${total} records`,
    }}
    bordered
    locale={{
      emptyText: isLoading ? "Loading..." : "No bonus data found",
    }}
  />
      </div>
    </div>
  );
}